export default __webpack_public_path__ + "static/media/970.ddaa50f2.png";